import { polyfill } from 'seamless-scroll-polyfill';

interface ScrollToRefOptions {
  behavior?: ScrollBehavior,
}

if (typeof window !== 'undefined') {
  polyfill();
}

export default function scrollToRef(element: HTMLElement, opts?: ScrollToRefOptions) {
  return () => {
    window.scrollTo({
      top: element.offsetTop,
      behavior: opts?.behavior || 'auto',
    });
  };
}
